import { render } from "./NotFoundComponent.vue?vue&type=template&id=05e63c00"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__